import { CSSObject } from 'styled-components';
import starryNight from '../../../../../../../assets/betgalaxy/images/header/quickAccessMenu/starryNight.png';

export const FlexGetVerified: CSSObject = {
  bg: `url(${starryNight})`,
  bgSize: 'cover',
};
